import { useNavigate, useParams } from "react-router-dom";
import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { CardDetailController } from "./card-detail-controller";
import { CardDetailPage } from "./card-detail-page";

export function CardDetailRoute({ deps }: { deps: AppDeps }) {
  const { cardId = "" } = useParams<{ cardId: string }>();
  const navigate = useNavigate();
  return (
    <Subtree
      key="card-detail"
      deps={[cardId]}
      controller={() =>
        new CardDetailController(pick(deps, "client", "authHandler", "storeRepository"), cardId, {
          back: () => navigate(-1),
          toCards: () => navigate("/cards"),
        })
      }
    >
      <CardDetailPage />
    </Subtree>
  );
}
